// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".transaction-status-screen--container {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  height: 100vh;\n  box-sizing: border-box; }\n\n.transaction-status-screen--container-icon {\n  background-color: var(--primary);\n  width: 100vw;\n  height: 201px;\n  padding-top: 35px;\n  padding-left: 47px; }\n\n.transaction-status-screen--image {\n  width: 180px;\n  height: 53px; }\n", ""]);
// Exports
module.exports = exports;
